export default __webpack_public_path__ + "static/media/beautiful-african-woman-2.87a9f036.png";